try {
  window._ = require("lodash");
  window.Popper = require("popper.js").default;
  window.$ = window.jQuery = require("jquery");
  require("jquery-migrate");
  window.moment = require("moment");
  window.AlertService2 = require("./services/AlertService2").default;
  window.LoadingService = require("./services/LoadingService").default;
  window.numberToNumero =
    require("./services/StringUtilService").numberToNumero;
} catch (e) { }

require("moment/locale/pt-br");
require("../../public/js/bootstrap.min.js");
require("../../public/js/jquery.easing.1.3.js");
require("../../public/js/jquery.waypoints.min.js");
require("../../public/js/jquery.stellar.min.js");
require("../../public/assets/js/basico-comum.js");
require("owl.carousel");
require("../../public/js/jquery.magnific-popup.min.js");
require("../../public/js/jquery.animateNumber.min.js");
require("../../public/js/scrollax.min.js");
require("../../public/js/main.js");
require("angular");
require("angular-sanitize");
require("angular-filter");
require("../../public/assets/framework/angular/app/site-app.js");
require("../../public/assets/framework/angular/custom/filters.js");
require("../../public/bower_components/angular-i18n/angular-locale_pt-br.js");
require("../../public/assets/framework/angular/custom/directives.js");
require("../../resources/assets/js/angularjs/custom/directives/whatsapp-site.js");
require("../../public/assets/plugins/angular/ng-mask/ngMask.min.js");
require("../../public/assets/plugins/angular-chosen-localytics/dist/angular-chosen.js");
require("../../public/bower_components/angular-elastic/elastic.js");
require("../../public/assets/plugins/gritter/js/jquery.gritter.js");
require("../../public/assets/js/HttpInterceptors.js");
require("../../public/bower_components/angular-recaptcha/release/angular-recaptcha.min.js");
require("../plugins/eonasdan-bootstrap-datetimepicker");
